import { ReactComponent as Antenna } from './feature-icons/antenna.svg';
import { ReactComponent as App } from './feature-icons/app.svg';
import { ReactComponent as Assembly } from './feature-icons/assembly.svg';
import { ReactComponent as CMore } from './feature-icons/c-more.svg';
import { ReactComponent as CardReader } from './feature-icons/card-reader.svg';
import { ReactComponent as Channels } from './feature-icons/channels.svg';
import { ReactComponent as Eurosport } from './feature-icons/eurosport.svg';
import { ReactComponent as FilmFavoritter } from './feature-icons/film-favoritter.svg';
import { ReactComponent as HBOMax } from './feature-icons/hbo-max.svg';
import { ReactComponent as HBONordic } from './feature-icons/hbo-nordic.svg';
import { ReactComponent as Internet } from './feature-icons/internet.svg';
import { ReactComponent as Max } from './feature-icons/max.svg';
import { ReactComponent as MovieRental } from './feature-icons/movie-rental.svg';
import { ReactComponent as NordiskFilmPlus } from './feature-icons/nordisk-film-plus.svg';
import { ReactComponent as ParamountPlus } from './feature-icons/paramount-plus.svg';
import { ReactComponent as RiktotoDirekte } from './feature-icons/riktoto-direkte.svg';
import { ReactComponent as Rooms } from './feature-icons/rooms.svg';
import { ReactComponent as SetTopBox } from './feature-icons/set-top-box.svg';
import { ReactComponent as Shipping } from './feature-icons/shipping.svg';
import { ReactComponent as SignalCoverageGuarantee } from './feature-icons/signal-coverage-guarantee.svg';
import { ReactComponent as SkyShowtime } from './feature-icons/skyshowtime.svg';
import { ReactComponent as StreamingServices } from './feature-icons/streaming-services.svg';
import { ReactComponent as TV } from './feature-icons/tv.svg';
import { ReactComponent as TV2Sport } from './feature-icons/tv2-sport.svg';
import { ReactComponent as Viaplay } from './feature-icons/viaplay.svg';
import { ReactComponent as Viasport } from './feature-icons/viasport.svg';
import { ReactComponent as WebTV } from './feature-icons/web-tv.svg';

export const FeatureIcons = {
  Antenna,
  App,
  Assembly,
  CMore,
  CardReader,
  Channels,
  Eurosport,
  FilmFavoritter,
  HBOMax,
  HBONordic,
  Internet,
  Max,
  MovieRental,
  NordiskFilmPlus,
  ParamountPlus,
  RiktotoDirekte,
  Rooms,
  SetTopBox,
  Shipping,
  SignalCoverageGuarantee,
  SkyShowtime,
  StreamingServices,
  TV,
  TV2Sport,
  Viaplay,
  Viasport,
  WebTV,
}